module.exports = __webpack_public_path__ + "img/biscuit.9789c559.svg";